module.exports = __webpack_public_path__ + "static/media/blue-loader.88412ce1.svg";